import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { api } from '../services/api';
import { useCart } from '../context/CartContext';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { toast } from '../components/ui/use-toast';
import { ArrowLeft } from 'lucide-react';
import CustomDesignerWizard from '../components/CustomDesignerWizard';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  console.log('[ProductDetail] Render - loading:', loading, 'product:', product?.name);

  useEffect(() => {
    console.log('[ProductDetail] Mounting with ID:', id);
    const fetchProduct = async () => {
      try {
        console.log('[ProductDetail] Fetching product...');
        const data = await api.getProduct(id);
        console.log('[ProductDetail] Product fetched:', data?.name);
        setProduct(data);
      } catch (error) {
        console.error('[ProductDetail] Error fetching product:', error);
      } finally {
        setLoading(false);
        console.log('[ProductDetail] Loading complete');
      }
    };

    fetchProduct();
  }, [id]);

  const handleAddToCart = (customizedProduct) => {
    addToCart(customizedProduct);
    toast({
      title: 'Added to cart!',
      description: `${customizedProduct.name} has been added to your cart.`,
    });
  };

  console.log('[ProductDetail] Render - loading:', loading, 'product:', product?.name);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <p className="text-xl text-gray-600">Loading product...</p>
          <p className="text-sm text-gray-400 mt-2">Product ID: {id}</p>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <h2 className="text-2xl font-medium text-gray-900 mb-4">Product not found</h2>
          <p className="text-gray-600 mb-4">Product ID: {id}</p>
          <Link to="/edible-greetings/catalog">
            <Button variant="outline">Back to Catalog</Button>
          </Link>
        </div>
      </div>
    );
  }

  // Handlers moved to CustomDesignerWizard component

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Back Button */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <button
            onClick={() => navigate('/edible-greetings/catalog')}
            className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Catalog
          </button>
        </div>
      </div>

      {/* Wizard */}
      <CustomDesignerWizard 
        product={product} 
        onAddToCart={handleAddToCart}
      />
    </div>
  );
};

export default ProductDetail;
